import { Component } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { AuthenticationService } from '../../../authentication/services/authentication.service';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbar } from '@angular/material/toolbar';
import { MatDrawer, MatDrawerContainer } from '@angular/material/sidenav';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ProfileCircleComponent } from '../profile-circle/profile-circle.component';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: true,
  imports: [
    MatIconModule,
    MatToolbar,
    MatDrawer,
    MatDrawerContainer,
    MatAccordion,
    RouterOutlet,
    TranslateModule,
    MatExpansionModule,
    MatButtonModule,
    FlexLayoutModule,
    RouterLink,
    ProfileCircleComponent,
  ],
})
export class ToolbarComponent {
  showSidenav: boolean = false;
  openMenu: boolean = false;

  constructor(
    public authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
  ) {
  }

  removeLocalStorage() {
    this.localStorageService.clearAll();
  }
}
